import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { FormControl, FormControlLabel, FormHelperText, FormLabel, Radio, RadioGroup } from "@mui/material";
import { visuallyHidden } from "@mui/utils";
import { useId } from "react";
import { Controller, get, useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
export const RadioInput = (props)=>{
    const labelId = useId();
    const errorId = useId();
    const formContext = useFormContext();
    const translation = useTranslation();
    const error = get(formContext.formState.errors, props.name);
    const optionValuesHash = props.options.reduce((acc, option)=>{
        acc[option.value] = option.value;
        return acc;
    }, {});
    const onChange = (field, value)=>{
        field.onChange(optionValuesHash[value] ?? value);
    };
    return /*#__PURE__*/ _jsx(Controller, {
        control: formContext.control,
        name: props.name,
        render: ({ field })=>/*#__PURE__*/ _jsxs(FormControl, {
                error: !!error,
                fullWidth: props.fullWidth,
                required: props.required,
                children: [
                    /*#__PURE__*/ _jsx(FormLabel, {
                        disabled: props.disabled,
                        id: labelId,
                        required: props.required,
                        sx: props.hideLabel ? visuallyHidden : undefined,
                        children: props.label
                    }),
                    /*#__PURE__*/ _jsx(RadioGroup, {
                        ...field,
                        "aria-describedby": errorId,
                        "aria-labelledby": labelId,
                        name: props.name,
                        onChange: (_event, value)=>onChange(field, value),
                        row: props.orientation === 'row',
                        children: props.options.map((option)=>/*#__PURE__*/ _jsx(FormControlLabel, {
                                control: /*#__PURE__*/ _jsx(Radio, {
                                    "aria-disabled": props.disabled || option.disabled,
                                    disabled: props.disabled || option.disabled,
                                    slotProps: {
                                        input: {
                                            // @ts-expect-error - necessary for testing purposes
                                            'data-testid': option.testId ?? (typeof option.label === 'string' ? option.label : option.value)
                                        }
                                    }
                                }),
                                label: option.label,
                                value: option.value
                            }, option.value))
                    }),
                    !props.hideError && /*#__PURE__*/ _jsx(FormHelperText, {
                        id: errorId,
                        children: translation.t(error?.message) || ' '
                    })
                ]
            })
    });
};
RadioInput.displayName = 'RadioInput';

//# sourceMappingURL=RadioInput.js.map